import { render, staticRenderFns } from "./NewBuyerDropdownField.vue?vue&type=template&id=6a84be90"
import script from "./NewBuyerDropdownField.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewBuyerDropdownField.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a84be90')) {
      api.createRecord('6a84be90', component.options)
    } else {
      api.reload('6a84be90', component.options)
    }
    module.hot.accept("./NewBuyerDropdownField.vue?vue&type=template&id=6a84be90", function () {
      api.rerender('6a84be90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/NewBuyerDropdownField.vue"
export default component.exports